import React, { useEffect } from 'react';

type JudgeMeOAuthMessage = {
    type: 'bustly:native-oauth-result';
    connected: boolean;
    success: boolean;
    code?: string | null;
    state?: string | null;
    flow?: string | null;
    platform?: string;
    connection?: string | null;
    account_name?: string | null;
    error?: string | null;
};

const NATIVE_OAUTH_RESULT_CHANNEL = 'bustly:native-oauth-result';
const nativeOAuthResultChannelName = (flow?: string | null): string => (
    flow ? `${NATIVE_OAUTH_RESULT_CHANNEL}:${flow}` : NATIVE_OAUTH_RESULT_CHANNEL
);

const buildJudgeMeOAuthMessage = (href: string): JudgeMeOAuthMessage => {
    const url = new URL(href);
    const result = url.searchParams.get('judgeme_oauth');
    const code = url.searchParams.get('code');
    const state = url.searchParams.get('state');
    const flow = url.searchParams.get('judgeme_flow');
    const hasAuthorizationCode = Boolean(code && state);
    const success = result === '1' || (!result && hasAuthorizationCode);
    return {
        type: 'bustly:native-oauth-result',
        connected: result === '1',
        success,
        code,
        state,
        flow,
        platform: url.searchParams.get('judgeme_platform') || undefined,
        connection: url.searchParams.get('judgeme_connection'),
        account_name: url.searchParams.get('judgeme_account'),
        error: url.searchParams.get('judgeme_error') || url.searchParams.get('error'),
    };
};

const JudgeMeOAuthCallbackPage: React.FC = () => {
    useEffect(() => {
        const message = buildJudgeMeOAuthMessage(window.location.href);

        try {
            const channel = new BroadcastChannel(nativeOAuthResultChannelName(message.flow));
            channel.postMessage(message);
            channel.close();
        } catch {
            // BroadcastChannel is a best-effort fallback for OAuth popups that lose window.opener.
        }

        if (window.opener && !window.opener.closed) {
            window.opener.postMessage(message, window.location.origin);
        }
        window.setTimeout(() => {
            window.close();
        }, 100);
    }, []);

    return (
        <div className="flex min-h-screen items-center justify-center bg-white px-6 text-center">
            <div>
                <h1 className="text-xl font-semibold text-[#1A162F]">Judge.me authorization complete</h1>
                <p className="mt-2 text-sm text-[#666F8D]">This window can be closed.</p>
            </div>
        </div>
    );
};

export default JudgeMeOAuthCallbackPage;
